import { render, staticRenderFns } from "./Personalities.vue?vue&type=template&id=c452abfc&"
import script from "./Personalities.vue?vue&type=script&lang=js&"
export * from "./Personalities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports